import { useQuery } from '@tanstack/react-query';
import { fetchUpcomingFestivalMaps } from '../../api/festivalMap';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

/** Every upcoming event with a map, soonest first — the Maps index's "Upcoming" section (minus the caller's own). */
export function useUpcomingFestivalMaps() {
  return useQuery({
    queryKey: queryKeys.festivalMap.upcoming(),
    queryFn: fetchUpcomingFestivalMaps,
    staleTime: STALE.semiStatic,
  });
}
